import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import uniqid from 'uniqid'

import './Switcher.scss'

export const SWITCHER_VARIANT_DEFAULT = 'default'
export const SWITCHER_VARIANT_BLUE = 'blue'

const uuid = uniqid()

export const Switcher = ({
  inputName,
  options,
  label,
  value,
  disabled,
  className,
  onChange,
  variant
}) => {
  const handleOnChange = e => {
    onChange(e.target.value)
  }

  return (
    <div className={classNames(['e-switcher', {
      'e-switcher--blue': variant === SWITCHER_VARIANT_BLUE
    }, className])}>
      {label && <span className={'e-switcher__label'}>{label}</span>}
      <div className={'e-switcher__options'}>
        {options.map((option, i) => (
          <label
            key={`e-switcher-option-${i}-${uuid}`}
            className={'e-switcher__option'}
            htmlFor={option.id}
            {...option.htmlAttrs}
          >
            <input
              type='radio'
              name={inputName}
              id={option.id}
              checked={option.value === value}
              onChange={handleOnChange}
              disabled={disabled}
              value={option.value}
            />
            <span className={'e-switcher__option__label'}>
              <span>{option.label}</span>
            </span>
          </label>
        ))}
      </div>
    </div>
  )
}

Switcher.defaultProps = {
  variant: SWITCHER_VARIANT_DEFAULT
}

/* istanbul ignore next */
Switcher.propTypes = {
  inputName: PropTypes.string,
  value: (props, propName, componentName) => {
    const isPresent = props[propName] !== undefined
    const isValid = props.options
      .map(({ value }) => value)
      .includes(props[propName])
    if (!isPresent) {
      return new Error(
        `Prop \`${propName}\` is required in ${componentName}\`.`
      )
    }
    if (!isValid) {
      return new Error(
        `Invalid prop \`${propName}\` supplied to
        \`${componentName}\`. Prop value must correspond to
        on of \`props.options\` values.`
      )
    }
  },
  options: PropTypes.arrayOf(
    (propValue, key, componentName, location, propFullName) => {
      const isValid =
        propValue.length >= 2 &&
        'label' in propValue[key] &&
        'value' in propValue[key]
      if (!isValid) {
        return new Error(
          `Invalid prop \`${propFullName}\` supplied to
          \`${componentName}\`. Prop value must be a tuple
          of objects with \`label\` and \`values\` keys.`
        )
      }
    }
  ).isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf([SWITCHER_VARIANT_DEFAULT,
    SWITCHER_VARIANT_BLUE])
}
